import Fraction from "fraction.js";
import QuestionModel from "../QuestionModel";
import QuestionValueFraction from "../QuestionValueFraction";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleFractionArithmetic extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        //this.generateOptions(question, data.values);
        //const answer = P3.utils.selectRandom(question.options);
        //question.values = [];
        switch (data.type) {
            case QuestionModel.TYPE_ADDITION        :
                return this.createAddition(question, data);
            case QuestionModel.TYPE_SUBTRACTION     :
                return this.createSubtract(question, data);
            case QuestionModel.TYPE_MULTIPLICATION  :
                return this.createMultiplication(question, data);
            case QuestionModel.TYPE_DIVISION        :
                return this.createDivide(question, data);
        }
    }

    createAddition(question, data) {

        let denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);

        //generate lhs of equal sign
        let k = 1000;
        while (k-- > 0 && question.values.length < data.values) {
            const numerator = P3.math.randomInt(data.range.min, Math.round(denominator / data.values) - 1);//keep the result less than 1
            question.values.push(new QuestionValueFraction(numerator, denominator));
        }

        //now lets work out the result
        let result = new Fraction(0, 1);
        for (let i = 0; i < question.values.length; i++) {
            const value = question.values[i];
            result = result.add(new Fraction(value.numerator, value.denominator));
        }

        //check whether result needs to be unsimplified again
        let scale = 1;
        let resultIsSimplified = false;
        if (result.d !== denominator) {
            resultIsSimplified = true;
            if (!data.simplify) {
                if (result.d !== denominator) {
                    scale = denominator / result.d;
                }
            }
        }

        //add to values
        question.values.push(new QuestionValueFraction(result.n * scale, result.d * scale));
        question.part = question.values.length - 1;

        question.options.push(new QuestionValueFraction(result.n * scale, result.d * scale));

        //if it simplified ensure our options use same denominator
        if (resultIsSimplified) denominator = result.d;

        //now lets add some random options
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, denominator - 1);
            if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                question.options.push(new QuestionValueFraction(numerator, denominator));
            }
        }

        //if we didn't manage to fill the options due to the denominator being very small (e.g. 2), put any old stuff in there
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, data.range.max);
            denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);
            if (numerator < denominator) {
                if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                    question.options.push(new QuestionValueFraction(numerator, denominator));
                }
            }
        }

        P3.utils.shuffleArray(question.options);

        return question;
        /*
        const answerIsResult = false;//ath.random() < 0.5;
        if (!answerIsResult) {

            let numerator;
            let k = 1000;
            while (k-- > 0) {
                numerator = P3.math.randomInt(data.range.min, data.range.max);
                //if (denominator === 1) denominator++;
                if (numerator < denominator) {
                    if (question.values.every(x => parseFloat(x.value) !== numerator / denominator)) {
                        question.values.push(new QuestionValueFraction(numerator, denominator));
                        break;
                    }
                }
            }

            //answer isn't a result, so add value and calculate answer
            //let numerator = P3.math.randomInt(question.range.min, question.range.max);
            if (Math.random() < 0.5) {
                question.values.push(answer);
                question.values.push(new QuestionValueFraction(numerator, denominator));
            } else {
                question.values.push(new QuestionValueFraction(numerator, denominator));
                question.values.push(answer);
            }
            const v0 = question.values[0];
            const v1 = question.values[1];
            const result = new Fraction(v0.numerator, v0.denominator).add(new Fraction(v1.numerator, v1.denominator));
            question.values.push(new QuestionValueFraction(result.n, result.d));
        } else {
            //otherwise the answer is the result (rhs of equals), which means we need to remove from answer to find this value
            let denominator = P3.math.randomInt(numerator + 1, question.range.max);
            question.values.push(new QuestionValueFraction(numerator, denominator));
            const v0 = question.values[0];
            const v1 = answer;

            const missingValue = new Fraction(v0.numerator, v0.denominator).sub(new Fraction(v1.numerator, v1.denominator));

            question.values.push(new QuestionValueFraction(missingValue.n, missingValue.d));
            question.values.push(answer);
        }

        question.part = question.values.indexOf(answer);

        return question;
        */
    }

    createSubtract(question, data) {
       let denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);

        const startValue = new QuestionValueFraction(denominator - P3.math.randomInt(1, 2), denominator);

        //push a big one onto values first to ovoid negative results
        question.values.push(startValue);

        //generate lhs of equal sign
        let k = 1000;
        while (k-- > 0 && question.values.length < data.values) {
            const numerator = P3.math.randomInt(data.range.min, Math.round(denominator / data.values) - 1);
            question.values.push(new QuestionValueFraction(numerator, denominator));
        }

        //now lets work out the result starting with start value
        let result = new Fraction(startValue.numerator, startValue.denominator);
        for (let i = 1; i < question.values.length; i++) {
            const value = question.values[i];
            result = result.sub(new Fraction(value.numerator, value.denominator));
        }

        //check whether result needs to be unsimplified again
        let scale = 1;
        let resultIsSimplified = false;
        if (result.d !== denominator) {
            resultIsSimplified = true;
            if (!data.simplify) {
                if (result.d !== denominator) {
                    scale = denominator / result.d;
                }
            }
        }

        //add to values
        question.values.push(new QuestionValueFraction(result.n * scale, result.d * scale));
        question.part = question.values.length - 1;

        question.options.push(new QuestionValueFraction(result.n * scale, result.d * scale));

        //if it simplified ensure our options use same denominator
        if (resultIsSimplified) denominator = result.d;

        //now lets add some random options
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, denominator - 1);
            if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                question.options.push(new QuestionValueFraction(numerator, denominator));
            }
        }

        //if we didn't manage to fill the options due to the denominator being very small (e.g. 2), put any old stuff in there
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, data.range.max);
            denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);
            if (numerator < denominator) {
                if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                    question.options.push(new QuestionValueFraction(numerator, denominator));
                }
            }
        }

        P3.utils.shuffleArray(question.options);

        return question;
        /*
        const numerator = P3.math.randomInt(1, question.range.min);
        const answerIsResult = Math.random() < 0.5;

        //todo - other branch doesn't work currently
        if (true) {
            //answer isn't a result, so add value and calculate answer
            let denominator = P3.math.randomInt(numerator + 1, question.range.max);

            question.values.push(new QuestionValueFraction(numerator, denominator));
            question.values.push(answer);

            const v0 = question.values[0];
            const v1 = question.values[1];
            const result = new Fraction(v0.numerator, v0.denominator).sub(new Fraction(v1.numerator, v1.denominator));
            question.values.push(new QuestionValueFraction(result.n, result.d));
        } else {
            //otherwise the answer is the result (rhs of equals), which means we need to remove from answer to find this value
            let denominator = P3.math.randomInt(numerator + 1, question.range.max);
            question.values.push(new QuestionValueFraction(numerator, denominator));
            const v0 = question.values[0];
            const v1 = answer;

            const missingValue = new Fraction(v0.numerator, v0.denominator).add(new Fraction(v1.numerator, v1.denominator));

            question.values.push(new QuestionValueFraction(missingValue.n, missingValue.d));
            question.values.push(answer);
        }

        question.part = question.values.indexOf(answer);
        */
        /*
        //for debug log the values out
        for (let i = 0; i < question.values.length; i++) {
            console.log(question.values[i].toString());
        }
        */

        //return question;

    }

    createMultiplication(question, data) {

        let denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);

        //generate lhs of equal sign
        let k = 1000;
        while (k-- > 0 && question.values.length < data.values) {
            const numerator = P3.math.randomInt(data.range.min, data.range.max);
            question.values.push(new QuestionValueFraction(numerator, denominator));
        }

        //now lets work out the result
        let result = new Fraction(1, 1);
        for (let i = 0; i < question.values.length; i++) {
            const value = question.values[i];
            result = result.mul(new Fraction(value.numerator, value.denominator));
        }

        //check whether result needs to be unsimplified again
        let scale = 1;
        let resultIsSimplified = false;
        if (result.d !== denominator) {
            resultIsSimplified = true;
            if (!data.simplify) {
                if (result.d !== denominator) {
                    scale = denominator / result.d;
                }
            }
        }

        //add to values
        question.values.push(new QuestionValueFraction(result.n * scale, result.d * scale));
        question.part = question.values.length - 1;

        question.options.push(new QuestionValueFraction(result.n * scale, result.d * scale));

        //if it simplified ensure our options use same denominator
        if (resultIsSimplified) denominator = result.d;

        //now lets add some random options
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, denominator - 1);
            if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                question.options.push(new QuestionValueFraction(numerator, denominator));
            }
        }

        //if we didn't manage to fill the options due to the denominator being very small (e.g. 2), put any old stuff in there
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, data.range.max);
            denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);
            if (numerator < denominator) {
                if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                    question.options.push(new QuestionValueFraction(numerator, denominator));
                }
            }
        }

        P3.utils.shuffleArray(question.options);

        return question;
        /*
        let numerator, denominator;

        const answerIsResult = Math.random() < 0.5;

        if (answerIsResult) {
            numerator = P3.math.randomInt(1, question.range.min);
            denominator = P3.math.randomInt(question.range.min + 1, question.range.max);
            question.values.push(new QuestionValueFraction(numerator, denominator));
            question.values.push(answer);

            const v0 = question.values[0];
            const v1 = question.values[1];

            const result = new Fraction(v0.numerator, v0.denominator).mul(new Fraction(v1.numerator, v1.denominator));
            question.values.push(new QuestionValueFraction(result.n, result.d));
        } else {
            numerator = P3.math.randomInt(1, question.range.min);
            denominator = P3.math.randomInt(question.range.min + 1, question.range.max);
            question.values.push(new QuestionValueFraction(numerator, denominator));

            const v0 = question.values[0];
            const v1 = answer;

            const missing = new Fraction(v1.numerator, v1.denominator).div(new Fraction(v0.numerator, v0.denominator));
            question.values.push(new QuestionValueFraction(missing.n, missing.d));

            question.values.push(answer);
        }

        question.part = question.values.indexOf(answer);//set answer index

        return question;

        */
    }

    createDivide(question, data) {

        let denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);

        //generate lhs of equal sign
        let k = 1000;
        while (k-- > 0 && question.values.length < data.values) {
            const numerator = P3.math.randomInt(data.range.min, data.range.max);
            question.values.push(new QuestionValueFraction(numerator, denominator));
        }

        //sort low to high to assure result is a fraction
        question.values.sort((a, b) => {
            return a.value - b.value;
        });

        const start = question.values[0];

        //now lets work out the result
        let result = new Fraction(start.numerator, start.denominator);
        for (let i = 1; i < question.values.length; i++) {
            const value = question.values[i];
            result = result.div(new Fraction(value.numerator, value.denominator));
        }

        //check whether result needs to be unsimplified again
        let scale = 1;
        let resultIsSimplified = false;
        if (result.d !== denominator) {
            resultIsSimplified = true;
            if (!data.simplify) {
                if (result.d !== denominator) {
                    scale = denominator / result.d;
                }
            }
        }

        //add to values
        question.values.push(new QuestionValueFraction(result.n * scale, result.d * scale));
        question.part = question.values.length - 1;

        question.options.push(new QuestionValueFraction(result.n * scale, result.d * scale));

        //if it simplified ensure our options use same denominator
        if (resultIsSimplified) denominator = result.d;

        //now lets add some random options
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, denominator - 1);
            if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                question.options.push(new QuestionValueFraction(numerator, denominator));
            }
        }

        //if we didn't manage to fill the options due to the denominator being very small (e.g. 2), put any old stuff in there
        k = 100;
        while (k-- > 0 && question.options.length < 5) {
            const numerator = P3.math.randomInt(data.range.min, data.range.max);
            denominator = P3.math.randomInt(data.range_denominator.min, data.range_denominator.max);
            if (numerator < denominator) {
                if (question.options.every(x => parseFloat(x.value) !== numerator / denominator)) {
                    question.options.push(new QuestionValueFraction(numerator, denominator));
                }
            }
        }

        P3.utils.shuffleArray(question.options);

        return question;

        /*
            let numerator, denominator;

            const answerIsResult = Math.random() < 0.5;

            if (answerIsResult) {
                numerator = P3.math.randomInt(1, question.range.min);
                denominator = P3.math.randomInt(question.range.min + 1, question.range.max);
                question.values.push(new QuestionValueFraction(numerator, denominator));
                question.values.push(answer);

                const v0 = question.values[0];
                const v1 = question.values[1];

                const result = new Fraction(v0.numerator, v0.denominator).div(new Fraction(v1.numerator, v1.denominator));
                question.values.push(new QuestionValueFraction(result.n, result.d));
            } else {
                numerator = P3.math.randomInt(1, question.range.min);
                denominator = P3.math.randomInt(question.range.min + 1, question.range.max);
                question.values.push(new QuestionValueFraction(numerator, denominator));

                const v0 = question.values[0];
                const v1 = answer;

                const missing = new Fraction(v1.numerator, v1.denominator).mul(new Fraction(v0.numerator, v0.denominator));
                question.values.push(new QuestionValueFraction(missing.n, missing.d));

                question.values.push(answer);
            }

            question.part = question.values.indexOf(answer);//set answer index
    */
        /*
        for (let i = 0; i < question.values.length; i++) {
            console.log(question.values[i].toString());
        }
        */

        //return question;


    }

    /*
    generateOptions(question, total) {
        const values = [];
        let count = 0;
        let n = 1000;
        while (n-- > 0) {
            const numerator = P3.math.randomInt(1, question.range.min);
            const denominator = P3.math.randomInt(2, question.range.max);
            const value = new QuestionValueFraction(numerator, denominator);
            if (values.indexOf(value.toString()) === -1) {
                question.options.push(value);
                values.push(value.toString());
                count++;
                if (count === total) break;
            }
        }
    }
    */
}